import { render, staticRenderFns } from "./interactive-text.vue?vue&type=template&id=84319a0e&scoped=true&"
import script from "./interactive-text.vue?vue&type=script&lang=js&"
export * from "./interactive-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84319a0e",
  null
  
)

export default component.exports